import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

/**
 * Service base para todas as APIs do sistema.
 * Centraliza a configuração da URL base da API.
 *
 * @remarks
 * - Em desenvolvimento (ng serve): usa http://localhost:8080
 * - Em produção (ng build): usa a URL do AWS API Gateway configurada em environment.prod.ts
 */
@Injectable({
  providedIn: 'root',
})
export abstract class ApiBaseService {
  /**
   * URL base da API configurada no arquivo environment
   * @protected
   */
  protected readonly apiBaseUrl = environment.apiBaseUrl;

  constructor(protected http: HttpClient) {}
}
